import http from "./../../services/http";

export const usersRequest = () => {
  return http.get("users");
};

export const searchUsersRequest = (nome) => {
  return http.get(`users?name=${nome}`);
};

export const usersShowRequest = (id) => {
  return http.get(`users/${id}`);
};

export const usersDeleteRequest = (id) => {
  return http.delete(`users/${id}`);
};

export const usersRestoreRequest = (id) => {
  return http.put(`users/${id}/restore`);
};

export const usersUpdateRequest = (payload) => {
  return http.put(`users/${payload.id}`, payload);
};

export const userUpdateMaxConcurrentLoginsRequest = (payload) => {
  return http.put(`users/sessions/max-concurrent-logins`, payload);
};

export const usersCreateRequest = (payload) => {
  return http.post(`users`, payload);
};

export const usersUploadAvatarRequest = (payload) => {
  console.log({ req: payload });
  return http.post(`users/upload/avatar`, payload);
};

export const usersUploadClubeRequest = (payload) => {
  console.log({ req: payload });
  return http.post(`users/upload/clube`, payload);
};
